export default "__VITE_ASSET__BJ0UZoS7__"